import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

export function getMuiDialog(theme: Theme): Components['MuiDialog'] {
  return {
    styleOverrides: {
      container: {
        [theme.breakpoints.down('sm')]: {
          alignItems: 'flex-end',
        },
      },

      paper: {
        '&:before': {
          display: 'block',
          content: '""',
          position: 'absolute',
          inset: '0',
          borderRadius: 12,
          padding: 2,
          background: `linear-gradient(155deg, ${theme.palette.secondary.light} 5.74%, ${theme.palette.primary.main} 9.03%, ${theme.palette.secondary.main} 14.22%, ${theme.palette.secondary.dark} 25.76%, ${theme.palette.background.default} 41.68%)`,
          mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
          maskComposite: 'exclude',
        },

        [theme.breakpoints.down('sm')]: {
          margin: 0,
        },
      },
    },
  };
}
